import { render, staticRenderFns } from "./BorcluIcraDosyasiPicker.vue?vue&type=template&id=4fc0d556"
import script from "./BorcluIcraDosyasiPicker.vue?vue&type=script&lang=ts"
export * from "./BorcluIcraDosyasiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports